import React from 'react'
import Grid from '@mui/material/Grid'
import './BuildingAndProperty.scss'

const WaterSupply = React.memo(({ waterSupplyEntity }) => {
  const waterSupply = React.useMemo(() => waterSupplyEntity || {}, [waterSupplyEntity])

  return (
    <>
    {waterSupply && 
    ((waterSupply.hydrantNearTheProperty && waterSupply.hydrantNearTheProperty.isChecked) ||
    (waterSupply.pondAdjacentToTheProperty && waterSupply.pondAdjacentToTheProperty.isChecked) ||
    waterSupply.fireSprinklerSystem || 
    waterSupply.haveAPool) ? (
      <h2 className="section-title">Water Supply</h2>
    ) : <></>}
    
        {waterSupply &&
        waterSupply.fireSprinklerSystem &&
          waterSupply.fireSprinklerSystem !== null ? (
          <Grid className="section">
            <label className="main-title-label">Fire sprinkler system: {waterSupply.fireSprinklerSystem ? <span className="answer">Yes</span> : ""}</label>
          </Grid>
        ) : null}

        {waterSupply &&
          waterSupply.hydrantNearTheProperty && 
          waterSupply.hydrantNearTheProperty !== null && 
          waterSupply.hydrantNearTheProperty.isChecked !== null &&
          waterSupply.hydrantNearTheProperty.isChecked ? (
          <Grid className="section">
            <label className="main-title-label">Hydrant Near Property: {waterSupply.hydrantNearTheProperty.isChecked ? (
              <span className="answer">
                Yes
                {waterSupply.hydrantNearTheProperty.isChecked && 
                  waterSupply.hydrantNearTheProperty.location !== null &&
                  waterSupply.hydrantNearTheProperty.location !== "" ? (
                    <>{`, ${waterSupply.hydrantNearTheProperty.location}`}</>
                  ) : null}
              </span>
            ) : ""}</label>
          </Grid>
        ) : null}

        {waterSupply &&
          waterSupply.haveAPool &&
          waterSupply.haveAPool !== null ? (
          <Grid className="section">
            {waterSupply.haveAPool ? <label className="main-title-label">Pool: <span className="answer">Yes</span></label> : ""}
          </Grid>
        ) : null}

        {waterSupply &&
          waterSupply.pondAdjacentToTheProperty && 
          waterSupply.pondAdjacentToTheProperty.isChecked &&
          waterSupply.pondAdjacentToTheProperty.isChecked !== null ? (
          <Grid className="section">
            <label className="main-title-label">Pond, river or stream on:
              <span className="answer"> Yes</span>
            </label>
          </Grid>
        ) : null}

        {waterSupply &&
          waterSupply.pondAdjacentToTheProperty && 
          waterSupply.pondAdjacentToTheProperty.dryHydrantConnection &&
          waterSupply.pondAdjacentToTheProperty.dryHydrantConnection !== null &&
          waterSupply.pondAdjacentToTheProperty.dryHydrantConnection.isChecked &&
          waterSupply.pondAdjacentToTheProperty.dryHydrantConnection.isChecked !== null ? (
          <Grid className="section">
            <label className="main-title-label">Dry Hydrant:
            {waterSupply.pondAdjacentToTheProperty.dryHydrantConnection.isChecked ? (
              <span className="answer">
                {" "}Yes
                {waterSupply.pondAdjacentToTheProperty.dryHydrantConnection.isChecked && 
                  waterSupply.pondAdjacentToTheProperty.dryHydrantConnection.location &&
                  waterSupply.pondAdjacentToTheProperty.dryHydrantConnection.location !== "" &&
                  waterSupply.pondAdjacentToTheProperty.dryHydrantConnection.location !== null ? (
                    <>{`, ${waterSupply.pondAdjacentToTheProperty.dryHydrantConnection.location}`}</>
                  ) : null}
              </span>
            ) : ""}</label>
          </Grid>
        ) : null}
    </>
  )
})

export default WaterSupply